import { axios } from '@/utils/request'

// 列表
export function getBrandOption(params) {
  return axios({
    url: '/distribution/brandOption',
    method: 'GET',
    params
  })
}
// 类型列表
export function getBrandOptionType(params) {
  return axios({
    url: '/distribution/brandOptionType',
    method: 'GET',
    params
  })
}
// 品牌组列表
export function getBrandGroup(params) {
  return axios({
    url: '/distribution/brandGroup',
    method: 'GET',
    params
  })
}
// 添加品牌组
export function addBrandGroup(data) {
  return axios({
    url: '/distribution/brandGroup',
    method: 'POST',
    data
  })
}
// 修改品牌组
export function putBrandGroup(data, id) {
  return axios({
    url: '/distribution/brandGroup/' + id,
    method: 'PUT',
    data
  })
}
// 删除品牌组
export function removeBrandGroup(data) {
  return axios({
    url: '/distribution/brandGroup/deletes',
    method: 'DELETE',
    data
  })
}
// 品牌列表
export function getBrand(params) {
  return axios({
    url: '/distribution/brand',
    method: 'GET',
    params
  })
}
// 添加品牌
export function addBrand(data) {
  return axios({
    url: '/distribution/brand',
    method: 'POST',
    data
  })
}
// 删除品牌
export function removeBrand(data) {
  return axios({
    url: '/distribution/brand/deletes',
    method: 'DELETE',
    data
  })
}
// 修改
export function putBrand(data, id) {
  return axios({
    url: '/distribution/brand/' + id,
    method: 'PUT',
    data
  })
}
// 复制
export function copyBrand(data) {
  return axios({
    url: '/distribution/brandGroup/copy',
    method: 'POST',
    data
  })
}
